module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "rContents_toc_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Contents#Contents_toc_4"
    }
  }, [_c('b', [_vm._v("two")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Contents#Contents_toc_4"
    }
  }, [_vm._v("The Basics of Weight Training")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "bodytext-right-1"
  }, [_vm._v("That’s what you get when you suffer—you get results.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-right"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—PAUL SHERWEN, TOUR DE FRANCE COMMENTATOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_vm._v("In this chapter, we will discuss the basics of weight training and address the most common questions that athletes have when starting a new program. Even if you have been lifting for years, it won’t hurt to review the basics. As the science and equipment of weight training continue to change, you may find that you still have a few things to learn.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("CHOOSING A GYM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-4"
  }, [_vm._v("Once you’ve made the commitment to use weight training to improve your riding performance, you need to decide where to work out. If there is not a functional gym in your home, you need to find a facility that offers weight training services. There are basically three types to choose from:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Health clubs and spas")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Bodybuilding gyms")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("School gyms and recreation centers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Public Gyms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-4"
  }, [_vm._v("Check out the gyms in your area to see whether they meet your needs. Many facilities will allow a free trial workout if you say you may be interested in joining. If possible, visit the gym at the time of day that you will usually be training so you can observe the patrons who will be sharing the weight room with you. You’ll also be able to gauge the traffic level; you don’t want to work out in a crowded gym where there’s a long wait to use each machine. Here is a list of considerations:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Is it in a convenient location? A facility close to home or work is preferable.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Is it clean and well-laid out?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Does it have a knowledgeable, educated staff? (See “"), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#coach"
    }
  }, [_vm._v("How to Choose a Trainer or a Coach")]), _vm._v("” later in the chapter).")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Does it have the appropriate equipment for your programmed exercises?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is the condition of the machines? Are they dirty or in need of repair?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What are the hours of operation? Does it work with your schedule?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Does the facility offer shower and locker facilities? This can be very important if you train before work or during lunchtime.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is the initial cost to join, and what are the monthly dues? Ask if there are any specials being offered. Many facilities offer a non-prime-time discount membership rate for those who will not be training during peak hours.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Home Gyms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A home gym holds certain advantages over a public gym. Exercising at home is convenient, and there are no crowds to contend with. You can save a lot of time by not having to drive to and from a facility, which can be a big plus. And, in the long run, it may be more economical to invest in the equipment required to outfit a home facility than to pay sign-up fees and monthly dues at a public gym.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course the home gym has disadvantages as well. Equipment limitations may keep you from performing some key exercises. Some people respond better in an environment in which they can feed off the energy of the people around them, so motivation may prove to be more difficult if you exercise alone. Also, motivation can be hard to sustain when you are surrounded by distractions, and there are always more distractions at home than in a facility dedicated to exercise. Whatever your preference, consider finding a workout partner. Having someone to train with is one of the greatest possible motivators.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-2"
  }, [_vm._v("To set up a home gym, you will need the proper equipment and space, preferably a well-lit, well-ventilated area that measures at least 10 by 10 feet. Here is a list of the basic equipment needed for a functional home gym:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("A sturdy flat bench")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("An adjustable barbell set")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("An adjustable dumbbell set")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-1"
  }, [_vm._v("With these three items, you will be able to perform many of the exercises in most strength training programs. With the addition of a pair of squat standards, you will be able to safely perform the squat, which is a key exercise of the cyclist’s weight training program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most difficult exercise to perform in a home setting is the leg curl, which works the hamstrings. This is a very important "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("muscle group for cyclists to develop, and it cannot be safely and efficiently exercised without a proper leg-curl machine or bench attachment. Many of the lower-priced devices on the market are not adjustable to different leg lengths and may put the athlete into an unsafe resistance arc while performing the exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("TYPES OF EQUIPMENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are many different types of resistance exercise equipment on the market. Hundreds of companies are producing machines, equipment, and various devices for the purpose of exercise. It may take a little bit of experimenting to find out what type works best for you. Rather than taking the advice of a salesperson, be sure to do your research through a reliable website such as "), _c('a', {
    attrs: {
      "href": "http://www.consumerreports.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.consumerreports.com")])]), _vm._v(" for unbiased ratings on the latest home exercise equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Free Weights")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Free weights, consisting of barbells and dumbbells, make up the most basic workout equipment in resistance training. Dating back to the athletes of ancient Greece, they epitomize the essence of weight training.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbell exercises are performed using a 7-foot-long Olympic barbell bar—which weighs 45 pounds unloaded—and different-sized weight plates ranging from 2.5 to 45 pounds. Many gyms also include a rack of fixed-weight barbells generally ranging from 10 to 150 pounds each. Most home gyms utilize a lighter 6-foot bar and weight-plate set.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dumbbells are a shorter version of the barbell and are designed to be held in one hand. In most public gyms you will find a large range of fixed-weight dumbbells. In home gyms, adjustable dumbbell sets are most common, but it can be more convenient "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("to own fixed-weight dumbbells in the weights you will most likely use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is necessary to use special benches (flat, incline, decline, and upright) to safely position yourself to perform specific free-weight exercises efficiently. Assorted weight bars and cable handle attachments may also be used to work specific muscle groups. To store loose equipment and assist you in certain exercises, special racks are available in most facilities.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Pros and Cons of Free Weights")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Pros")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Exercises may be performed in a very functional manner. Dumbbells may be used to imitate motions found in sport or daily activities; free weights require greater coordination and balance to perform than other modes of resistance training, which leads to increased joint stabilization.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-2"
  }, [_c('i', [_vm._v("Cons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When using free weights, you are working against gravity. Thus, it may be very difficult to work specific muscle groups as effectively as on a resistance machine that is built specifically for that purpose. Also, free-weight exercises may be difficult for beginners and can lead to injury if not performed correctly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Resistance Machines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Resistance weight training machines come in a tremendous variety. The most common type found in clubs and gyms has a weight stack connected to a lever bar by chains and cables. The weights can be changed easily by moving the pin in the stack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In recent years, there has been a boom in resistance weight machines for the home market. Although the quality and design of some machines are suspect, there are many very good pieces "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("of equipment available that are close to commercial-gym quality. They are, however, expensive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Pros and Cons of Resistance Machines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Pros")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Machines are safer and easier to use than free weights. They allow for specific, isolated movements that are either difficult or impossible to perform with free weights. The weights can also be changed quickly, allowing for a speedier workout. Resistance can be provided over a full range of motion for each muscle group.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-2"
  }, [_c('i', [_vm._v("Cons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-index"
  }, [_vm._v("By limiting the user to single-joint movements in fixed planes of motion, machines do not promote the balance, coordination, and joint stabilization that come from using free weights. Weight machines are also expensive and take up a lot of space. And even with the range-of-motion adjustments that are available with some machines, it may not be possible to fit the user properly.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "image0"
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "2",
      "src": "images/line.jpg",
      "width": "450"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "grayline"
  }), _vm._v(" "), _c('p', {
    staticClass: "boxtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("a brief history of resistance machines")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("The first machines built for gym use were designed by Harold Zinkin in the 1950s. Soon Zinkin’s Universal Gym machines were found in nearly every gym from high schools to health clubs. These machines were commonly multistationed, allowing an entire group to use them at one time to perform a large variety of exercises. The Universal Gym greatly simplified weight training, thus making it more appealing, especially to newcomers.")]), _vm._v(" "), _c('p', {
    staticClass: "box-indent"
  }, [_vm._v("The next stage in resistance weight training machines came in the 1960s with the development of Nautilus machines by Arthur Jones. These machines employed an off-center cam designed to provide a perfectly balanced resistance throughout the full range of motion of the exercise. By the 1970s, Nautilus machines were found in gyms and clubs nationwide. Their popularity continued to grow, and today they are still used in facilities around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "box-indent"
  }, [_vm._v("The 1980s saw dozens of companies jumping into the resistance machine market. Suddenly there were many machines that closely resembled their Universal and Nautilus predecessors. Competition brought about new innovations in machine development.")]), _vm._v(" "), _c('p', {
    staticClass: "box-indent"
  }, [_vm._v("One of the complaints regarding earlier resistance machine models was that they did not properly fit different-sized people. In addition, there were no range-of-motion adjustments. Weight machine manufacturers responded to these issues by designing equipment with more and more special features. Most machines can now be set to a special fit for each user, which is an advantage for people with orthopedic limitations and rehabilitation needs.")]), _vm._v(" "), _c('p', {
    staticClass: "grayline"
  }), _vm._v(" "), _c('p', {
    staticClass: "image0"
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "2",
      "src": "images/line.jpg",
      "width": "450"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Resistance Bands")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-5"
  }, [_vm._v("A simple and inexpensive technique of applying resistance to the muscles is the use of elastic resistance bands. Once an exercise mode limited to physical therapy rehabilitation using surgical tubing, resistance bands are now found at nearly all workout facilities. The ease and safety of use make them perfect for those just getting started in strength training. Resistance bands are very effective for isolating specific small muscle groups as well as for performing complex multiplane exercises that simulate sports motions. There are many exercises that may be performed using resistance bands, but their use is limited to warm-ups, light strengthening, and rehabilitation. Some large muscle groups may be difficult to work effectively using this method.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3a"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('b', [_vm._v("Swiss Balls")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two decades ago, these large inflatable balls were found only in physical therapy facilities. Now you can’t find a gym without them. Swiss balls may be used to perform hundreds of exercises. These inexpensive pieces of gym equipment greatly enhance core and joint stability development by providing an unstable base for exercise performance. They are used for many of the core exercises in this book and may also be used in place of a bench or chair to add difficulty to upper-body exercises.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Medicine Balls")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-index"
  }, [_vm._v("Medicine balls have long been used in fitness regimens. The early-model sand-filled leather balls have been replaced by bouncy rubber-covered models. These weighted balls are useful in performing a number of exercises. Holding and moving them force you to engage and stabilize your core muscles in a very functional manner.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("CLOTHING AND PERSONAL EQUIPMENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It may seem silly to be told what to wear to the gym, but you would be surprised by what some people show up in. The most important thing is to wear comfortable clothing that allows full movement and isn’t too hot. Gone are the days when the amount of sweat was the measure of a good workout.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-2"
  }, [_c('i', [_vm._v("Gloves")]), _vm._v(". Weight lifting gloves are designed to prevent hands from slipping off the bars or grips. They have padded palms and cut-off "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("fingertips, much like bike gloves. Most bike gloves have too much padding for a good barbell grip, but they may be useful in a pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-2"
  }, [_c('i', [_vm._v("Shoes")]), _vm._v(". It is very important that the shoes worn while lifting weights be supportive and cushioned. Do not wear running shoes while performing high-risk exercises, as they don’t provide any lateral support. Avoid other loose-fitting shoes or sandals because you could slip or lose some toes—then those new $200 bike shoes wouldn’t quite fit! Mishaps happen when least expected; protect yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-2"
  }, [_c('i', [_vm._v("Weight belts")]), _vm._v(". Weight lifting belts are highly recommended for performing heavy or high-risk exercises such as squats, power cleans, and dead lifts. Weight belts come in different widths, waist sizes, and materials, including nylon and leather. Many people favor the newer nylon belts because they don’t require a break-in period, but most diehards prefer leather.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "coach"
    }
  }, [_vm._v("HOW TO CHOOSE A TRAINER OR A COACH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ideally, we would all have a qualified coach to design and monitor a program for us. He or she would oversee all of our workouts, making sure that we warm up and stretch, that our exercise form is correct, and that proper rest intervals are taken between sets—and that we stay motivated to work toward our goals. Unfortunately, we do not all have coaches to help us through each workout. If we did, there would be no reason to read this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though the main purpose of this book is to inform cyclists about the proper way to design a year-round weight training program and the correct way to perform each exercise, we highly encourage you to seek out the advice of a qualified fitness trainer, even if just for an hour twice per year. One-on-one "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("instruction can be very motivating and beneficial, especially when you are in the early stages of weight training. It is important that the person you choose have sound qualifications and experience. Otherwise the information you receive may not help and may even hurt you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-2"
  }, [_vm._v("Keep in mind that the term “certified trainer” provides no guarantee of a person’s qualifications. Numerous certifications are offered by different organizations, and some of these organizations are well-established and have high testing standards. Some require that applicants have a college degree. However, others have no education requirement whatsoever. The field of personal training is one of the fastest-growing in the nation. It seems that every man or woman who has ever lifted a weight—and many who have not—is jumping on the bandwagon to make big bucks in the fitness business. As a consumer, you need to make an informed, careful decision when choosing a trainer. Protect yourself by asking a potential training coach the following questions:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Are you certified? If so, by what organization(s)? Look for one or more of these: the National Strength and Conditioning Association (NSCA), the American College of Sports Medicine (ACSM), and the National Academy of Sports Medicine (NASM). Coaches licensed by the United States Cycling Federation (USCF) do not necessarily have a strong weight training background. Be sure to check.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Do you have a college education? What did you major in? Is it a science- or exercise-related degree?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is your experience as a trainer? Other background?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is your training philosophy?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Are you familiar with the training needs of a cyclist? Ask him or her what those are, and see if they match "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("up with the concepts and program found in this book. A good trainer will be open to having you share your program and working on it with you.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("May I call any of your other clients for a reference?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is the fee per session? Is there a discount for buying five or more sessions in advance?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-3"
  }, [_vm._v("Whether you will be hiring a trainer just to introduce you to the equipment and check your form or will be meeting with him or her for every training session, you need to make sure that your personalities mesh. This may be difficult to judge in your introduction, but if you feel that your trainer is not motivating you or does not possess good teaching skills, move on to another. Remember, you are the consumer and athlete, and you deserve to work with the best person available.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "image0"
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "2",
      "src": "images/line.jpg",
      "width": "450"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "grayline"
  }), _vm._v(" "), _c('p', {
    staticClass: "boxtitle"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("gym etiquette")])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("The gym is another world. There is a subculture that lives by a special set of unwritten rules of conduct. Most things are commonsense, but there are a few rituals you may need to become aware of. The following is a quick rundown of these common courtesies, and we’ve placed them in order of our pet peeves when they’re not followed.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RERACK YOUR WEIGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("Help keep the weight room safe and functional by reracking, and encourage others to do the same. Replace dumbbells and barbells when you are finished with them, and strip the weight plates off a bar or machine when you are done using it, even if it wasn’t empty when you got to it.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXERCISE WITH A TOWEL")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("Place a towel on the cushion when using a machine, and be certain to wipe up any sweat you may have left on the grips.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SHARE THE EQUIPMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("In a crowded gym, for example at 5:00 p.m., a lot of people are trying to use the same equipment. If you see someone resting on a machine between sets, simply ask, “Can I work in with you?” Most often the person will get up and let you use the machine during their rest interval. If you change the adjustments on the machine, return them to how you found them after your set.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BE AWARE OF YOUR SURROUNDINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("Especially when you’re using free weights, you may move around the room to perform exercises. If you are standing or have moved a bench to use, make sure you are not blocking traffic or interfering with someone else’s exercise. Be sure not to stand between someone and the mirror when they are using it.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WATCH THE NOISE")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("The acceptable noise level varies among facilities. Some places cater to hard-core bodybuilders and power lifters and crank up heavy-metal music to a deafening level. Others cater to families or a more mature crowd and choose to play Muzak. Whatever the case, be aware of the noise you are making, be it excessive grunting and groaning or loose headphones that let the whole room share in your personal motivational tunes.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USE THE LOCKERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("Some gyms resemble a 12-year-old’s room: Gym bags, sweatshirts, water bottles, towels, and books litter every corner. Keep your stuff stowed away from the workout area.")]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent1"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SAFETY")])])]), _vm._v(" "), _c('p', {
    staticClass: "box-noindent"
  }, [_vm._v("We cannot emphasize enough how important it is to learn and always follow the rules of safety, especially when training in a public facility. In most instances, common sense is the first step toward increasing safety.")]), _vm._v(" "), _c('p', {
    staticClass: "grayline"
  }), _vm._v(" "), _c('p', {
    staticClass: "image0"
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "2",
      "src": "images/line.jpg",
      "width": "450"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("GENERAL NUTRITION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you probably know, proper nutrition plays a critical role in your success as an athlete. A sound diet will improve overall performance both on and off the bike by helping to reduce body fat, fuel the body for hard training, improve recovery after training, and optimize your overall health. It is beyond the scope of this book to give detailed nutrition information, but here are a few basics you should understand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("The Skinny on Fat")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-5"
  }, [_vm._v("During the “carbohydrate craze” of the early 1980s, fat was officially labeled the athlete’s enemy. Everyone was obsessed with severely limiting fat, or eliminating it from their diet altogether. It was a pasta-and-bagel world, with athletes bragging to each other about how high they had made the carbohydrate percentage of their diets. However, in recent years science has shown that the body needs certain essential fats to remain healthy. Not all fats are bad for you. Monosaturated and omega-3 fats are the good ones; they are generally found in nuts, avocados, and fish oils. Saturated fats, found in dairy products and some meats, are the bad ones. Try to stay clear of saturated and partially hydrogenated fats, and keep your overall intake of fat to less than 30 percent of total calories.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3a"
  }, [_c('b', [_vm._v("What about Protein?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For many years, a high-protein diet has been associated with weight lifting and bodybuilding. Visions of big meatheads gulping down raw eggs and eating Fred Flintstone steaks come to most people’s minds when they think about the protein needs of athletes. The truth is that the protein demand for athletes is not much higher than that of the average person. The current "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("recommended dietary allowance (RDA) of protein is 0.8 gram per kilogram of body weight. The protein needs of a weight training athlete would be 1.0 to 1.5 grams per kilogram (1 kilogram is 2.2 pounds). This may seem like a significant increase, but most Americans eat twice the RDA of protein, anyway. The best advice is to emphasize slightly more protein from low-fat sources.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("We Still Love Carbs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As previously mentioned, there has been a carbohydrate craze among athletes since the 1980s, and it still lives on in the minds of many people. The truth is, there is nothing wrong with athletes consuming a lot of carbohydrates. The Atkins low-carb diet has no place for athletes who require energy to perform well. Carbohydrates are the primary fuel used in muscular contractions. The energy from them can be released within exercising muscles up to three times faster than energy from fat. Some carbohydrates enter the bloodstream quickly and give an immediate energy boost, but this dramatic rise can also lead to a dramatic fall. By combining carbohydrates with protein-rich, low-fat foods, your energy level will tend to remain steady, and your appetite will stay satisfied longer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("Don’t Forget Water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dehydration may be the most common cause of premature fatigue during sports training and competition. Even low levels of dehydration impair physiological function and performance. On average, you need to drink eight to twelve 8-ounce glasses (two to three quarts or liters) of water per day. If the weather is hot or you have been training harder than usual, increase this amount. If you are well-hydrated, you should be urinating a clear or nearly clear stream approximately every two hours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("Keep in mind that you should be ingesting electrolytes along with water when hydrating. Electrolytes are important because they are what your cells use to maintain voltages across their membranes and to carry electrical impulses (nerve impulses, muscle contractions) across them and to other cells. When you exercise heavily, you lose electrolytes, particularly sodium and potassium, in your sweat. These must be replaced to keep the electrolyte concentrations of your body fluids constant. Generally, your everyday diet should provide adequate amounts of electrolytes. However, if you are exercising heavily in extremely hot weather, you should be conscious of your electrolyte intake. For this reason, many sports drinks have sodium chloride or potassium chloride added to them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although it is rare for someone to drink too much water, it is worth mentioning that extreme overconsumption can have serious ill effects. A condition known as hyponatremia occurs when the sodium in your blood is diluted by excess water. This may result from medical conditions that impair excretion of water from your body or from a significant increase in water consumption, such as by athletes competing in marathons and other endurance events. Hyponatremia is an abnormally low concentration of sodium in your blood. When your blood sodium is too low, your cells malfunction, causing swelling. In acute hyponatremia, sodium levels drop rapidly, resulting in potentially dangerous effects, such as rapid brain swelling, which can result in coma and death.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("When to Eat")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eating several smaller meals throughout the day rather than the typical big three will help keep blood-sugar levels more constant as well as control your appetite. One important rule is to eat after you work out. Carbohydrate (glycogen) stores in the body are limited, and you must replenish these depleted stores "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("following a hard workout. Most cyclists are good about this practice following a hard ride, but the same holds true after a vigorous weight training session. Within the first 30 minutes of completing your workout, the body is much more capable of replenishing the fuel stores that you just used. During this window of time, try to consume carbohydrates and protein in the form of a snack, a small meal, or even a recovery sports drink. You’ll probably find that focusing on recovery after a workout means you’ll feel and perform better the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-3"
  }, [_c('b', [_vm._v("A Few Words on Supplements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A staggering number of dietary supplements are available on the market today. It is not within the scope of this book to address each one individually, but we will offer the following remarks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By definition, a supplement is something added to the diet to make up for a deficiency. If you suffer from a nutritional deficiency, then supplementation may be right for you. On the other hand, if you are seeking a miracle supplement to increase your muscle development; drop body fat; or stimulate your energy level, strength, or endurance, then you are just the gullible person the miracle manufacturers are aiming for. The old saying, “If something sounds too good to be true, it probably is,” is true of most dietary supplements.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’ve all seen the magazine ads making incredible claims. The manufacturers, distributors, and retailers of supplements rely mainly on such advertising to market their goods. Have you ever noticed that these companies do not make the same unsupported claims on the product label? In fact, if there is anything at all on the label, it is usually a disclaimer stating that the effect of the supplement has not been evaluated by the Food and Drug Administration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-2"
  }, [_vm._v("If you are interested in taking supplements, do not get your nutritional advice from advertisements or meatheads in the gym. If you can, set up an appointment with a registered dietitian "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("to get your questions answered. If you cannot do that, then at least investigate product advertisements that may be biased and deceptive. Consider the following when looking at a supplement:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Are the product claims backed by scientific research?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("If scientific research has been done, has it been presented in a scientific journal?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Check to see if the manufacturer conducted the research itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Does the manufacturer own or publish the journal in which the research was presented?")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet-hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Are the research findings taken out of context by the claims?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-1"
  }, [_vm._v("Most times there is no credible basis for the manufacturers’ claims regarding the efficacy of supplements. Some products not only do not provide the claimed effect but may be downright dangerous. Use good judgment as a consumer, and realize that there is no substitute for proper nutrition. In fact, one study has stated that “there are no known nutritional deficiencies associated with sport training that would necessitate supplementation over normal ingestion of food and drink.” More often than not, our advice to athletes is to take the amount of money they were about to spend on a miracle supplement and spend it at a good produce market instead.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61133703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter2.vue
// module id = 84
// module chunks = 0